import { in_array, is_numeric, intval, strval, identical, compare } from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { array, slot, values, type Arr } from './access';
import { catalogRows } from './catalog';
export interface SizeDefenseDeps {
    resolve_adv_dis_layer_sources(row: Arr, layer: string, numericPresence: boolean): Arr;
    layer_value(row: Arr, layer: string): unknown;
    item_field(row: Arr, field: string): unknown;
    get_target_type(row: Arr): string;
}
/** PHP: janus_size_gated_defense_sources (includes/functions/janus/encounter/size_gated_defenses.php:47) */
export function janusSizeGatedDefenseSources(defender: Arr, layer: string, env: PortEnv<SizeDefenseDeps>): Arr {
    if (!in_array(layer, ['immune_to_forced_movement_from_size_category_number_below', 'immune_to_status_effect_prone_from_size_category_number_below'], true)) return [];
    const sources = array(env.deps.resolve_adv_dis_layer_sources(defender, layer, true)), own = env.deps.layer_value(defender, layer);
    if (is_numeric(own)) sources.append({ kind: strval(env.deps.item_field(defender, 'item_type') ?? 'creature'),
        name: strval(env.deps.item_field(defender, 'item_name') ?? 'Creature'), item_id: env.deps.item_field(defender, 'item_id'), value: intval(own) });
    return sources;
}
/** PHP: {closure@107:411} (includes/functions/janus/encounter/size_gated_defenses.php:107) */
export function closure107SizeDefenseSort(a: Arr, b: Arr, env: PortEnv<SizeDefenseDeps>): number {
    for (const row of [b, a]) if (!array(row).has('value')) env.warn('Undefined array key "value"', 2);
    return compare(slot(b, 'value'), slot(a, 'value'));
}
/** PHP: janus_size_gated_defense_blocking_source (includes/functions/janus/encounter/size_gated_defenses.php:72) */
export function janusSizeGatedDefenseBlockingSource(defender: Arr, source: Arr, layer: string, env: PortEnv<SizeDefenseDeps>): Arr | null {
    if (!in_array(env.deps.get_target_type(source), ['creature', 'player_character'], true)) return null;
    if (env.deps.get_target_type(defender) === 'inventory') return null;
    const sources = janusSizeGatedDefenseSources(defender, layer, env);
    if (values(sources).length === 0) return null;
    const sourceId = strval(slot(source, 'encounter_creatures', 'encounter_creature_id') ?? ''), defenderId = strval(slot(defender, 'encounter_creatures', 'encounter_creature_id') ?? '');
    if (sourceId !== '' && sourceId === defenderId) return null;
    if (sourceId === '' && defenderId === '' && identical(source, defender)) return null;
    const sizes = [...catalogRows('SizeType').values()].map(row => slot(row, 'item_id')),
        defenderRank = sizes.indexOf(strval(env.deps.layer_value(defender, 'size') ?? '')), sourceRank = sizes.indexOf(strval(env.deps.layer_value(source, 'size') ?? ''));
    if (defenderRank === -1 || sourceRank === -1) return null;
    const best = (values(sources) as Arr[]).sort((a, b) => closure107SizeDefenseSort(a, b, env))[0]!;
    return sourceRank <= defenderRank + Number(slot(best, 'value')) ? best : null;
}
